import { createSlice } from "@reduxjs/toolkit";

import { statesNames, statesAndResources } from "./sensorAnalysisConstants";

export const isResourceInState = (state, resource) => {
  return statesAndResources[state]?.resources?.includes(resource);
};

const initialState = {
  sensorAnalysisState: statesNames.EXIT,
  sensorsData: [],
  isSensorsDataFetched: false,
  ui: {
    isSubmitting: false,
    error: null,
  },
  preRay: {
    configurations: [],
  },
  manualMeshing: {
    state: {
      sensors: [],
      sensorOffset: {
        x: 0,
        y: 0,
        z: 0,
      },
      selectedSensors: [],
    },
  },
  skyline: {
    isVisible: false,
    selectedSensor: null,
  },
  windowSkyline: {
    isVisible: false,
  },
};

const sensorAnalysisSlice = createSlice({
  name: "sensorAnalysis",
  initialState,
  reducers: {
    setPreRayConfigurations: (state, action) => {
      state.preRay.configurations = action.payload;
    },
    applyActionToSensorAnalysisState: (state, action) => {
      const actionName = action?.payload;
      const currentState = state.sensorAnalysisState;
      const nextState = statesAndResources?.[currentState]?.[actionName];
      if (nextState) state.sensorAnalysisState = nextState;
    },
    setSensorAnalysisState: (state, action) => {
      state.sensorAnalysisState = action.payload;
    },

    setSensorsData: (state, action) => {
      state.sensorsData = action.payload;
    },
    setIsSensorsDataCalled: (state, action) => {
      state.isSensorsDataFetched = action.payload;
    },
    setSensorAnalysisSubmitting: (state, action) => {
      state.ui.isSubmitting = action.payload;
    },
    setSensorAnalysisError: (state, action) => {
      state.ui.error = action.payload;
    },
    setManualMeshingSensors: (state, action) => {
      state.manualMeshing.state.sensors = action.payload ?? [];
    },
    setManualMeshingSensorOffset: (state, action) => {
      state.manualMeshing.state.sensorOffset = {
        ...state.manualMeshing.state.sensorOffset,
        ...action.payload,
      };
    },
    resetManualMeshingSensorOffset: (state) => {
      state.manualMeshing.state.sensorOffset = {
        x: 0,
        y: 0,
        z: 0,
      };
    },
    setManualMeshingSelectedSensors: (state, action) => {
      state.manualMeshing.state.selectedSensors = action.payload;
    },
    setSkylineVisible: (state, action) => {
      state.skyline.isVisible = action.payload;
    },
    setSkylineSelectedSensor: (state, action) => {
      state.skyline.selectedSensor = action.payload;
      if (action.payload) {
        state.skyline.isVisible = true;
      }
    },
    setWindowSkylineVisible: (state, action) => {
      state.windowSkyline.isVisible = action.payload;
    },
  },
});

export const {
  applyActionToSensorAnalysisState,
  setSensorsData,
  setSensorAnalysisSubmitting,
  setSensorAnalysisError,
  setManualMeshingSensors,
  setManualMeshingSensorOffset,
  setManualMeshingSelectedSensors,
  resetManualMeshingSensorOffset,
  setIsSensorsDataCalled,
  setSkylineVisible,
  setSkylineSelectedSensor,
  setWindowSkylineVisible,
  setSensorAnalysisState,
  setPreRayConfigurations,
} = sensorAnalysisSlice.actions;

export default sensorAnalysisSlice.reducer;
